export class OrderCalculateRequest {

    addressId:String;
    amount:String;
    quantity:String;
    typeDeliveryId: String;
    typeShippingId: String;
    weight: String;
    
}